export default {
      id: "map-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#map",
      toString: function () {
        return this.url;
      }
    }